/* eslint-disable no-unused-vars */
import { useCategoryTree } from "@/hooks/category/useCategoryTree";
import { mergeGuestCart } from "@/utils/MergeGuestCart";
import { useEffect, useRef } from "react";

import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import { useCart } from "@/context/cart";

import Footer from "./footer";
import Header from "./header";
import Navbar from "./Navbar";
import FixedBox from "./FixedBox";
import Categories from "./categories-bar/Categories";
import FloatingWhatsapp from "./FloatingWhatsapp";
import useShowOnScroll from "@/hooks/useShowOnScroll";
import TopHeader from "./TopHeader";
import useSWR from "swr";
import { getCookie, getCookies } from "cookies-next";
import { getHeaderJson } from "@/services/global";
import CMSAlert from "./CMSAlert";
import toast from "react-hot-toast";
import { handleAddToActiveCart } from "@/utils/global";
import { event_failed_payment } from "@/utils/gtm";

const Layout = ({ children, className }) => {
  const { locale, push, query } = useRouter();
  const handshake = getCookie("handshake");
  const checkout_data = getCookies();
  const { dispatch: dispatchCart } = useCart();
  const { data: session } = useSession();

  // check if payment failed show error in toast
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!!query?.order_id && query?.success === "false") {
        handleAddToActiveCart(handshake, query?.order_id, push);
        event_failed_payment(checkout_data);
        toast.error(
          locale === "en"
            ? "Payment Failed, Please try again"
            : "فشلت عملية الدفع, برجاء المحاولة مره اخرى"
        );
      }
    }, 500);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, locale, push, handshake]);

  // merge guest cart to user cart
  useEffect(() => {
    mergeGuestCart(session, dispatchCart);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  useCategoryTree();

  const { isShowOnScroll } = useShowOnScroll(20);

  // header json
  const { data } = useSWR(
    () => `header-json-${locale}`,
    () => getHeaderJson(handshake),
    {
      revalidateOnFocus: false,
    }
  );

  const headerJson = data?.data?.data || [];
  // if (pathname.endsWith("/baseeta")) {
  //   return <main className={`${className}`}>{children}</main>;
  // } else
  return (
    <main className={`${className}`}>
      <TopHeader />
      <CMSAlert headerJson={headerJson} />

      <div
        className={`sticky top-0 z-[1000] ${isShowOnScroll ? "shadow-md" : ""}`}
      >
        <Header headerJson={headerJson} />
        <Navbar
          {...{
            locale,
            push,
            headerJson,
          }}
        />
      </div>
      <Categories locale={locale} />

      {children}
      <FloatingWhatsapp />
      <Footer />
      <FixedBox locale={locale} />
    </main>
  );
};

export default Layout;
